<template>
    <div class="table-container">
        <div class="p-0 pt-2 pb-1 header-panel-container">
            <mdb-navbar class="z-depth-1 p-0 pl-2 rounded-sm justify-content-between">
                <mdb-navbar-brand class="table-header-navbar-brand">
                    <mdb-tabs class="table-header-tabs" :active="0" default :links="[{ text: 'In Transit' }]" />
                </mdb-navbar-brand>
                <form class="form-inline ml-auto" @submit.prevent="$emit('search')">
                    <input class="form-control mr-sm-2 table-searchterm-input border border-light"
                        :value="searchTerm" @input="$emit('update:searchTerm', $event.target.value)"
                        type="text" maxlength="100" placeholder="Document / Vendor / Reference" aria-label="Search in-transit documents" />
                    <mdb-btn type="submit" color="elegant" size="sm" :disabled="loading"><i class="el-icon-search"></i> Search</mdb-btn>
                    <mdb-btn type="button" color="elegant" size="sm" :disabled="loading" @click="$emit('clear')"><i class="el-icon-close"></i> Clear</mdb-btn>
                    <mdb-btn type="button" color="elegant" size="sm" :disabled="loading" @click="$emit('refresh')"><i class="el-icon-refresh"></i> Refresh</mdb-btn>
                </form>
            </mdb-navbar>
        </div>
        <div class="d-flex flex-wrap justify-content-between">
            <el-radio-group :value="type" @input="$emit('update:type', $event)" size="small" class="mb-2">
                <el-radio-button label="grn">GRNs</el-radio-button>
                <el-radio-button label="purchase-order">Purchase Orders</el-radio-button>
            </el-radio-group>
            <slot name="connection"></slot>
        </div>
        <p class="small text-muted mb-2">Non-cancelled GIT-01 GRNs and their linked purchase orders, including historical documents. Quantities are document quantities, not current available stock.</p>
        <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon class="mb-2" />
        <el-table v-loading="loading" class="custom-element-table" :data="rows" row-key="DocEntry"
            border stripe size="small" height="calc(100vh - 245px)"
            :empty-text="error ? 'Unable to load documents' : 'No in-transit documents found'">
            <el-table-column type="index" label="#" width="60" />
            <el-table-column prop="DocNum" :label="type === 'grn' ? 'GRN No.' : 'PO No.'" width="150">
                <template slot-scope="scope">
                    <el-button type="text" @click="$emit('row-click', scope.row)">{{ scope.row.DocNum }}</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="DocDate" label="Document Date" width="170" />
            <el-table-column prop="DocDueDate" label="Due Date" width="170" />
            <el-table-column prop="CardCode" label="Vendor Code" width="140" />
            <el-table-column prop="CardName" label="Vendor Name" min-width="220" />
            <el-table-column prop="NumAtCard" label="Vendor Reference" min-width="170" />
            <el-table-column prop="DocStatus" label="Document Status" width="150">
                <template slot-scope="scope">{{ scope.row.DocStatus === 'O' ? 'Open' : (scope.row.DocStatus === 'C' ? 'Closed' : scope.row.DocStatus) }}</template>
            </el-table-column>
            <el-table-column label="Action" width="100" align="center">
                <template slot-scope="scope"><el-button type="text" icon="el-icon-view" @click="$emit('row-click', scope.row)">View</el-button></template>
            </el-table-column>
        </el-table>
        <el-pagination layout="total, sizes, prev, pager, next, jumper" :current-page="page" :page-size="length"
            :page-sizes="[25, 50, 100]" :total="total" :disabled="loading"
            @current-change="$emit('page-change', $event)" @size-change="$emit('size-change', $event)" />
    </div>
</template>

<script>
import { mdbBtn, mdbNavbar, mdbNavbarBrand, mdbTabs } from 'mdbvue';

export default {
    name: 'InTransitDocumentTable',
    components: { mdbBtn, mdbNavbar, mdbNavbarBrand, mdbTabs },
    props: {
        rows: { type: Array, default: () => [] },
        type: { type: String, default: 'grn' },
        searchTerm: { type: String, default: '' },
        page: { type: Number, default: 1 },
        length: { type: Number, default: 25 },
        total: { type: Number, default: 0 },
        loading: { type: Boolean, default: false },
        error: { type: String, default: '' }
    }
};
</script>
